import clsx from "clsx";

export const Pill: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  return (
    <div
      className={clsx(
        "bg-gray-800/70 px-3 py-1 text-white font-mono rounded-bl-md rounded-tr-md",
      )}
    >
      {children}
    </div>
  );
};

export const LabelPill: React.FC<{
  label: React.ReactNode;
  value: React.ReactNode;
  size?: "sm" | "md" | "lg";
}> = ({ label, value, size }) => {
  return (
    <Pill>
      <p
        className={clsx(
          "text-gray-300",
          size === "sm" ? "text-xs" : size === "md" ? "text-sm" : "text-base",
        )}
      >
        {label}
      </p>
      <p
        className={clsx(
          "text-white",
          size === "sm" ? "text-sm" : size === "md" ? "text-base" : "text-lg",
        )}
      >
        {value}
      </p>
    </Pill>
  );
};
